
import InputValidationStore from "../../../../../commonreact/main/factoryservices/inputvalidation/InputValidationsStore";
import AppLanguageService from "../../AppLanguageService";

export class OnAppInit {

  constructor() {
    new AppLanguageService();
    new InputValidationStore();
  }
}